<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <div
      class="cf-content"
      v-html="termsAndConditionsContent"
    />

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      @click="closeModalClickHandler"
    >
      Okay
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'LoyaltyTermsAndConditions',

    computed: {
      ...mapGetters('content', ['content']),

      termsAndConditionsContent() {
        return this.content.PayAtTableLoyaltyProgramDetails.metadata.termsAndConditions;
      }
    },

    methods: {
      closeModalClickHandler() {
        this.$closeModal('loyaltyTermsAndConditionsModal');
      }
    }
  };
</script>
